/**
 * Logger de depuração do frontend.
 *
 * Fica ATIVO também em produção (para permitir depurar direto no console do
 * navegador). Pode ser desligado/ligado a qualquer momento pelo próprio console:
 *
 *   FaturamentoDebug.off()   // desliga (persiste em localStorage)
 *   FaturamentoDebug.on()    // liga
 *   FaturamentoDebug.status()
 */

const STORAGE_KEY = 'faturamento.debug'

function readFlag() {
  try {
    return localStorage.getItem(STORAGE_KEY)
  } catch {
    return null
  }
}

// Padrão: ligado. Só fica desligado se o usuário gravar explicitamente 'off'.
let enabled = readFlag() !== 'off'

const COLORS = {
  debug: 'color:#64748b',
  info: 'color:#0092b8;font-weight:600',
  warn: 'color:#b45309;font-weight:600',
  error: 'color:#dc2626;font-weight:600',
}

function stamp() {
  return new Date().toISOString().slice(11, 23)
}

function emit(level, scope, args) {
  // Erros sempre aparecem, mesmo com o debug desligado.
  if (!enabled && level !== 'error') return
  const method = level === 'debug' ? 'log' : level
  console[method](`%c[${stamp()}] [${scope}]`, COLORS[level], ...args)
}

export const log = {
  debug: (scope, ...args) => emit('debug', scope, args),
  info: (scope, ...args) => emit('info', scope, args),
  warn: (scope, ...args) => emit('warn', scope, args),
  error: (scope, ...args) => emit('error', scope, args),

  /** Loga um erro de requisição axios com todo o contexto útil. */
  http(scope, error) {
    const res = error?.response
    emit('error', scope, [
      {
        message: error?.message,
        code: error?.code,
        status: res?.status,
        statusText: res?.statusText,
        url: error?.config?.baseURL ? error.config.baseURL + error.config.url : error?.config?.url,
        method: error?.config?.method?.toUpperCase(),
        requestId: res?.headers?.['x-request-id'],
        data: res?.data,
      },
    ])
  },
}

export function setDebug(on) {
  enabled = !!on
  try {
    localStorage.setItem(STORAGE_KEY, on ? 'on' : 'off')
  } catch {
    /* localStorage indisponível — mantém só em memória. */
  }
  return enabled
}

export function isDebugEnabled() {
  return enabled
}

// Atalho global para uso no console do navegador em produção.
if (typeof window !== 'undefined') {
  window.FaturamentoDebug = {
    on: () => setDebug(true),
    off: () => setDebug(false),
    status: () => ({ enabled, flag: readFlag() }),
  }
}

export default log
